import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(3),
  },
  count: {
    marginRight: `0 ${theme.spacing(2)}`,
  },
  tableContainer: {
    flex: '1 1 auto',
    margin: `0  ${theme.spacing(3)}`,
    padding: `0  0 ${theme.spacing(3)}`,
    overflow: 'clip',
    height: 'calc(100vh - 200px)',
  },
  scrollContainer: {
    height: 'calc(100vh - 64px)',
    overflow: 'auto',
    paddingBottom: theme.spacing(0.5),
  },
  scrollBox: {
    height: `calc(100vh - 64px)`,
    display: 'flex',
    flexDirection: 'column',
  },
  pageContainer: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  deviceDetailsIcon: {
    padding: theme.spacing(1),
    paddingLeft: 0,
  },
}));

export default useStyles;
